import React, { useState,useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import '../../assets/css/login-register.css';
import '../../assets/css/mobile-login-register.css';

export default function Login() {
    const navigate = useNavigate();
    const { login, loginWithGoogle } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const googleBtnRef = useRef(null);

    // Handle email/password login
    const handleLogin = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const user_type = await login(email, password, toast);
            if (user_type === 'Admin') {
                toast.success('Login Successful');
                navigate('/admin/dashboard');
            } else if (user_type === 'Customer') {
                toast.success('Login Successful');
                navigate('/customer/dashboard');
            } else {
                toast.error('Invalid user type');
            }
        } catch (error) {
            toast.error('Invalid Credentials!');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Google login wrapper
    const GoogleLoginButton = ({ onLogin }) => (
        <GoogleLogin
            onSuccess={async (credentialResponse) => {
                const token = credentialResponse.credential;
                const userRole = await onLogin(token, toast);
 
                if (userRole === 'Admin') {
                    toast.success('Login Successful');
                    navigate('/admin/dashboard');
                } else if (userRole === 'Customer') {
                    toast.success('Login Successful');
                    navigate('/customer/dashboard');
                } 
            }}
            onError={() => toast.error('Google Login Failed')}
        />
    );

    // Trigger hidden button click
    const triggerHiddenGoogleLogin = () => {
        if (googleBtnRef.current) {
            googleBtnRef.current.querySelector('div[role=button]')?.click();
        }
    };

    return (
        <div className="login-saction">
            <div className="container">
                <div className="left-side-login">
                    <div className="logo">
                        <Link to="/login">
                            <img src={`${process.env.PUBLIC_URL}/images/Logo-login.svg`} alt="logo" />
                        </Link>
                    </div>
                    <h2>Login</h2>
                    <span>Welcome back! Please enter your details</span>
                    <div className="from-login">
                        <form onSubmit={handleLogin}>
                            <div className="row-input">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email Address"
                                    required
                                />
                            </div>
                            <div className="row-input">
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Password"
                                    required
                                />
                            </div>
                            <button type="submit" disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>
                        </form>

                        <div className="or-row">Or</div>
                        <div className="other-link-button-google" style={{ display: 'none' }} ref={googleBtnRef}>
                            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                                <GoogleLoginButton onLogin={loginWithGoogle} />
                            </GoogleOAuthProvider>
                        </div>
                        <div className="other-link-button">
                            <button className="custom-google-button" onClick={triggerHiddenGoogleLogin}>
                                <img src={`${process.env.PUBLIC_URL}/images/google.png`} alt="google-icon" /> Continue with Google
                            </button>
                        </div>
                        {/*<div className="other-link-button">
                            <Link to="/login">
                                <img src={`${process.env.PUBLIC_URL}/images/google.png`} alt="google.png" />
                                Continue with Google
                            </Link>
                            <Link to="/login">
                                <img src={`${process.env.PUBLIC_URL}/images/facebook.png`} alt="facebook.png" />
                                Continue with Facebook
                                </Link>
                        </div>*/} 

                        <p className="create-account">
                            Don’t have an account? <Link to="/register">Create Account</Link>
                        </p>
                    </div>
                </div>

                <div className="right-side-login">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/woman-enjoying-rural-surroundings.jpg`}
                        alt="Login visual"
                    />
                </div>
            </div>
        </div>
    );
}
